import React, { useState, useEffect } from "react";
import Context from "../Context";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";

export default function ContextProvider({ children }) {
  const [loadingFullScreen, setLoadingFullScreen] = useState(false);
  // Language
  const [selectedCountry, setSelectedCountry] = useState({
    code: "BR",
    name: "Brazil",
  });
  // Config sideBar
  const getKeyDisplayMenu = localStorage.getItem("sideBar");
  const [displayMenu, setDisplayMenu] = useState(
    getKeyDisplayMenu ? getKeyDisplayMenu : "",
  );
  const [displayIcon, setDisplayIcon] = useState("");
  const urlCode = window.location.href.split("dashboard/")[1];
  const userSector = JSON.parse(localStorage.getItem("user"));
  // Config Setor Inicial
  const [selectedValueSector, setSelectedValueSector] = useState({
    stR_description: urlCode
      ? urlCode
      : userSector?.sector.stR_description
        ? userSector?.sector.stR_description
        : "01CORTE",
    stR_SAPCode: userSector?.sector.stR_SAPCode
      ? userSector?.sector.stR_SAPCode
      : "01CORTE",
  });
  // Config Ficha
  const [loadingFicha, setLoadingFicha] = useState(false);
  const [loadingIndustryPartsTable, setIndustryPartsTable] = useState(false);
  const [loadingWagonTable, setLoadingWagonTable] = useState(false);
  const [partFlowObj, setPartFlowObj] = useState({});
  const [idStep, setIdStep] = useState(0);
  const [infoPiece, setInfoPiece] = useState("");
  // Config Info
  const [pecasObj, setPecasObj] = useState();
  const [glassLotObj, setGlassLotObj] = useState();
  const [moldesObj, setmoldesObj] = useState();
  const [toolMasurementsObj, setToolMasurementsObj] = useState({});
  const [materialFormObj, setMaterialFormObj] = useState({});
  const [codeMaterials, setCodeMaterials] = useState();
  const [moldsSector, setMoldsSector] = useState([]);
  // Config Racks
  const [bufferObj, setBufferObj] = useState({});
  //Forno
  const [fornoObj, setFornoObj] = useState({});
  // Pedido
  const [SalesOrdersObj, setSalesOrdersObj] = useState({});
  // Imagem
  const [showmodalIMG, setShowmodalIMG] = useState(false);
  // Pendência
  const [toolTipText, setToolTipText] = useState("Vazio");
  const [statusPendencia, setStatusPendencia] = useState(false);
  // Modal Ficha
  const [showModalFicha, setShowModalFicha] = useState(false);

  // Ficha
  const [code, setCode] = useState("");
  const [parts, setParts] = useState([]);
  const [originalParts, setOriginalParts] = useState([]);
  const [wagon, setWagon] = useState([]);
  const [selectedFurnace, setSelectedFurnace] = useState();
  const [furnace, setFurnace] = useState([]);
  const [partsByFurnace, setPartsByFurnace] = useState([]);
  const [confirmedWagon, setConfirmedWagon] = useState([]);
  const [selectedWagon, setSelectedWagon] = useState();
  const [similarParts, setSimilarParts] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [moldesEstoque, setMoldesEstoque] = useState([]);
  const [searchWagon, setSearchWagon] = useState("");

  const [itemsPriority, setItemsPriority] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [saga_Componentes, setSaga_Componentes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modelModal, setModelModal] = useState();

  useEffect(() => {
    localStorage.setItem("sideBar", displayMenu);
  }, [displayMenu]);

  const getStatusSideBar = () => {
    return displayMenu ? "navbar-is-not-visible" : "";
  };

  const getSector = async () => {
    try {
      const { data } = await blogFetch.get("/sector");
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  // Fluxo
  const getPartFlow = async (params) => {
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(
        `/SAGAViewOrdemApontamentos/${params.ordem}`,
      );
      setPartFlowObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFicha(false);
    }
  };

  // Get Info - Start
  const getPecas = async (params) => {
    try {
      const { data } = await blogFetch.get(`/ConsumpitonCost/${params.ordem}`);
      setPecasObj(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getGlassLot = async (params) => {
    try {
      const { data } = await blogFetch.get(`/GlassLot/${params.ordem}`);
      setGlassLotObj(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getGlassComponent = async (params) => {
    try {
      const { data } = await blogFetch.get(
        `/GlassLot/componente/${params.ordem}`,
      );
      setSaga_Componentes(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getMoldes = async (params) => {
    try {
      const { data } = await blogFetch.get(
        `/iSAGAViewMoldesGalgas/${params.ordem}`,
      );
      setmoldesObj(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getToolMasurementsObj = async () => {
    try {
      const { data } = await blogFetch.get(`/ToolMasurements/${codeMaterials}`);
      setToolMasurementsObj(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  // Formula
  const getMaterialForm = async (params) => {
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(`/MaterialReserve/${params.ordem}`);
      let array = [];
      data.map((eachObj, index) => array.push(eachObj.COD_MATERIAL));
      setMaterialFormObj(data);
      setCodeMaterials(array.join(";"));
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFicha(false);
    }
  };
  // Get Info - End

  // Info
  const handleInfo = async (data) => {
    try {
      setLoadingFicha(true);
      
      await Promise.all([
        getPecas(data),
        getGlassLot(data),
        getGlassComponent(data), // 👈 adicionado
        getMoldes(data),
        getToolMasurementsObj(),
        getMaterialForm(data),
      ]);

      setIdStep(2);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFicha(false);
    }
  };

  // Racks
  const getBuffers = async (params) => {
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(`/Buffer/${params.ordem}`);
      setBufferObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFicha(false);
    }
  };

  // Pedido
  const getSalesOrdersBI = async (params) => {
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(
        `/ISAGAViewInfoPedidos/${params.pedido}`,
      );
      setSalesOrdersObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFicha(false);
    }
  };

  const getFicha = async (order) => {
    try {
      const response = await blogFetch.get(`/SAGAViewFichaCabecalho/${order}`);
      return response.data[0];
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getMolds = async () => {
    try {
      setLoadingFicha(true);
      setLoading(true);
      const { data } = await blogFetch.get(`/ISAGA_VagoesFornosPecas/molds`);
      return data;
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getChangeMolds = async (moldeKey) => {
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas/getChangeMolds/` + moldeKey,
      );
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const putMold = async (params) => {
    try {
      setLoadingFullScreen(true);

      const payload = {
        vagao_Key: params.vagao_Key,
        molde_Key: params.molde_Key,
        ordem_Serial: params.ordem_Serial,
        status: params.status,
      };

      await blogFetch.put(`/ISAGA_Moldes/fornoPecas`, payload);

      const objModal = {
        quantidade_Passagem: params.qtd_Passagem,
        quantidade_Passagem_Max: params.qtd_PassagemMax,
        vagao_Key: params.vagao_Key,
        molde_Key: params.molde_Key,
        ordem_Serial: params.ordem_Serial,
        molde_Lote: params.molde_Lote,
        molde_Codigo: params.molde_Codigo,
        molde_Descricao: params.molde_Descricao,
        molde_Estoque: params.molde_Estoque,
      };

      if (params.qtd_Passagem === params.qtd_PassagemMax - 1) {
        setOpenModal(true);
        setModelModal(objModal);
      }

      const response = await getMolds();
      if (response) {
        setMoldsSector(response);
      }

      toast.success("Molde atualizado com sucesso", { autoClose: 4000 });
    } catch (error) {
      toast.error("Não foi possível atualizar o molde", { autoClose: 4000 });
      console.error("Erro ao atualizar o molde:", error);
    } finally {
      setLoadingFullScreen(false);
    }
  };

  const getParts = async (sector) => {
    try {
      const { data } = await blogFetch.get(`/SAGAViewPecasSetor/${sector}`);
      setParts(data.sagaViewPecasSetor);
      setOriginalParts(data.sagaViewPecasSetor);
    } catch {
      console.error("Error");
    }
  };

  const postAutomaticPendencia = async (params) => {
    try {
      await blogFetch.post("/ISAGA_Pendencias", params);
    } catch (error) {
      console.error(error);
    }
  };

  const filterGetPartsByFurnace = (parts) => {
    return parts.find(
      ({ moldIsTrue, pecasSetor, wagonIsTrue }) =>
        moldIsTrue &&
        !wagonIsTrue &&
        !(
          pecasSetor?.pend_Key &&
          pecasSetor?.ordem_SetAtual === pecasSetor?.pendMotOrigem_SAPSector
        ),
    );
  };

  const postWagon = async (peca, selectedFurnace, status, statusWagon) => {
    setLoadingFullScreen(true);

    try {
      if (
        !status ||
        statusWagon ||
        (peca?.pend_Key &&
          peca?.ordem_SetAtual === peca?.pendMotOrigem_SAPSector)
      ) {
        setLoadingFullScreen(false);
        return;
      }

      let parts = await getPartsByFurnace(selectedFurnace, true);
      let attempts = 0;

      while (true) {
        if (attempts++ > 20) {
          console.warn(
            "Limite de tentativas atingido. Parando para evitar loop.",
          );
          break;
        }

        const piece = filterGetPartsByFurnace(parts);
        if (!piece) break;

        const pecaSetor = piece.pecasSetor;

        if (!piece.moldIsTrue || piece.wagonIsTrue) break;

        const ok = await attemptCreateWagon(pecaSetor, selectedFurnace, piece);

        if (!ok) {
          parts = await getPartsByFurnace(selectedFurnace, true);
          continue;
        }

        break;
      }
    } finally {
      setLoadingFullScreen(false);
    }
  };

  const attemptCreateWagon = async (peca, selectedFurnace, piece) => {
    try {
      const { data } = await blogFetch.post(
        `/ISAGA_CombinacoesPecas/combinations`,
        {
          Ordem_Serial: peca.ordem_Serial,
          Forno: selectedFurnace,
        },
      );
      setWagon(data);
      return true;
    } catch (e) {
      const { response: { data } = {} } = e;
      if (data?.message) {
        return false;
      }
      console.error("Error: ", e);
      return false;
    }
  };

  const createAutomaticPendencia = async (pecaSetor) => {
    const params = {
      Pend_Ordem: pecaSetor.ordem_Serial,
      Pend_Status: "ABERTO",
      Pend_Mot_key: 33,
      PendMot_Responsavel: "Produção",
      Pend_Obs: `NÃO FOI POSSÍVEL CRIAR COMBINAÇÃO - Ordem Serial: ${pecaSetor.ordem_Serial} | Produto: ${pecaSetor.subProduto} | Peça: ${pecaSetor.ordem_Part_Cod} | Fórmula ${pecaSetor.formulaCod}`,
    };
    await postAutomaticPendencia(params);
  };

  const getFurnace = async () => {
    try {
      const { data } = await blogFetch.get("/SAGA_Fornos");
      setFurnace(data);
      return data;
    } catch {
      console.error("Error");
    }
  };

  const getPartsByFurnace = async (furnace, internalCall = false) => {
    if (!internalCall) setLoadingFullScreen(true);
    try {
      const { data } = await blogFetch.get(
        `/SAGAViewPecasSetor/Parts?sector=06CURVAD - Buffer&furnace=${furnace}`,
      );
      setPartsByFurnace(data);
      return data;
    } catch {
      console.error("Error");
      return [];
    } finally {
      if (!internalCall) setLoadingFullScreen(false);
    }
  };

  const getMoldesEstoque = async (centro) => {
    try {
      const { data } = await blogFetch.get(
        `SAGAViewPecasSetor/MoldesEstoque?Centro=${centro}`,
      );
      setMoldesEstoque(data);
      return data;
    } catch {
      console.error("Error");
      setMoldesEstoque([]);
    }
  };

  const getConfirmedWagon = async (status, selectedFurnace) => {
    setConfirmedWagon([]);
    setSearchWagon("");
    try {
      setLoading(true);
      setDisableButton(true);
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas?status=${status}&furnace=${selectedFurnace}`,
      );
      const url = data.map((item) => {
        if (item.wagonInfo.vagao_Image)
          item.wagonInfo.vagao_Image +=
            "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D";
        return item;
      });
      setConfirmedWagon(url);
    } catch {
      console.error("Error");
    } finally {
      setDisableButton(false);
      setLoading(false);
    }
  };

  const getHourByFurnace = async (furnace) => {
    try {
      const arrPromise = furnace.map(async (item) => ({
        forno: item.forno_Name,
        data: await blogFetch.get(
          `/ISAGA_VagoesFornos/hour/LIBERADO?furnace=${item.forno_Name}`,
        ),
      }));
      const response = await Promise.all(arrPromise);
      return response;
    } catch (error) {
      toast.success("Não foi possível carregar status do Fornos!", {
        duration: 4000,
      });
    }
  };

  const getSimilarParts = async (params) => {
    setLoading(true);
    try {
      const { data } = await blogFetch.get(
        `/ISAGA_SimilarParts?ordem=${params.ordem}`,
      );
      setSimilarParts(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const getFornosHitorico = async (params) => {
    setLoadingFicha(true);
    try {
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornos/getForno?ordem=${params.ordem}`,
      );
      setFornoObj(data);
    } catch (error) {
      console.error(error);
      setLoadingFicha(false);
    } finally {
      setLoadingFicha(false);
    }
  };

  const state = {
    setLoading,
    loading,
    displayMenu,
    setDisplayMenu,
    displayIcon,
    setDisplayIcon,
    getStatusSideBar,
    selectedValueSector,
    setSelectedValueSector,
    getSector,
    loadingFicha,
    setLoadingFicha,
    getPartFlow,
    idStep,
    setIdStep,
    partFlowObj,
    setPartFlowObj,
    handleInfo,
    getPecas,
    getGlassLot,
    getGlassComponent,
    saga_Componentes,
    setSaga_Componentes,
    getMoldes,
    getToolMasurementsObj,
    getMaterialForm,
    pecasObj,
    setPecasObj,
    glassLotObj,
    setGlassLotObj,
    moldesObj,
    setmoldesObj,
    toolMasurementsObj,
    setToolMasurementsObj,
    materialFormObj,
    setMaterialFormObj,
    codeMaterials,
    setCodeMaterials,
    getBuffers,
    bufferObj,
    setBufferObj,
    getSalesOrdersBI,
    SalesOrdersObj,
    setSalesOrdersObj,
    showmodalIMG,
    setShowmodalIMG,
    toolTipText,
    setToolTipText,
    statusPendencia,
    setStatusPendencia,
    showModalFicha,
    setShowModalFicha,
    selectedCountry,
    setSelectedCountry,
    infoPiece,
    setInfoPiece,
    code,
    setCode,
    getFicha,
    loadingIndustryPartsTable,
    setIndustryPartsTable,
    getMolds,
    putMold,
    getChangeMolds,
    moldsSector,
    setMoldsSector,
    wagon,
    postWagon,
    setWagon,
    parts,
    setParts,
    getParts,
    originalParts,
    setOriginalParts,
    furnace,
    setFurnace,
    getFurnace,
    selectedFurnace,
    setSelectedFurnace,
    setPartsByFurnace,
    partsByFurnace,
    getPartsByFurnace,
    setConfirmedWagon,
    confirmedWagon,
    getConfirmedWagon,
    loadingWagonTable,
    setLoadingWagonTable,
    setLoadingFullScreen,
    loadingFullScreen,
    setSelectedWagon,
    selectedWagon,
    getHourByFurnace,
    getSimilarParts,
    similarParts,
    setDisableButton,
    disableButton,
    moldesEstoque,
    setMoldesEstoque,
    getMoldesEstoque,
    setSearchWagon,
    searchWagon,
    setItemsPriority,
    itemsPriority,
    setInputValue,
    inputValue,
    status,
    setStatus,
    getFornosHitorico,
    fornoObj,
    openModal,
    setOpenModal,
    modelModal,
  };

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
